import { useState } from 'react';

export const useAuthorizedController = (roles?: string[] | null) => {
  const [isAuthorized, setIsAuthorized] = useState<boolean>(false);

  const validateRoles = async () => {
    // TODO: Get users roles and validate against roles specified for auth component
    let bearer = sessionStorage.getItem('token');
    let userRoles = sessionStorage.getItem('roles');

    if (roles && roles?.length > 0) {
      if (userRoles && bearer) {
        let parsedUserRoles: any[] = JSON.parse(userRoles);
        parsedUserRoles.forEach((element) => {
          let found = roles.indexOf(element) > -1;
          if (found) {
            setIsAuthorized(true);
            return;
          }
        });
      }
    } else {
      let acctInfo: any = sessionStorage.getItem('msal.account.keys');
      let signedIn: any = false;
      if (acctInfo) {
        acctInfo = JSON.parse(acctInfo);
        let id: any = sessionStorage.getItem(acctInfo[0]);
        if (id) {
          id = JSON.parse(id!);

          if (id.username != null && id.clientInfo != null) {
            signedIn = true;
          }
        }
      }
      if (bearer || signedIn) {
        setIsAuthorized(true);
        return;
      }
    }
  };

  const clearValidation = () => {
    setIsAuthorized(false);
  };

  return {
    // functions
    validateRoles,
    clearValidation,
    // state
    isAuthorized,
  };
};
